$(document).ready(function(){  
  $(".return-btn button").on('click', function() {

      	if(history.length > 1 && document.referrer != ""){
			window.history.back();
        } else {
         	location.href = "https://www.stonecandles.com/pages/collection"; 
        }

  });

  // window.wsaio_execute_custom_code = null;
});



// $(document).bind('DOMNodeInserted', function(e) {
//   // $('.lwst').remove();
//   $('.productitem').each(function(index, item) {
//     // This will remove the duplicate on the display
//     $(this).find('.lwst').not(':last').remove();

//     // This will remove the compare at price for the tiering
//     if($(this).find('.lwst').length > 0) {
//       $(this).find('.price--compare-at').remove();
//     }
//   });
// });